<template>
    <b-container class="my-3">
        <b-row>
            <b-col><label for="demo-sb"><strong>{{ $translate('start_row_no') }}</strong></label></b-col>
            <!-- -->
            <b-col><b-form-spinbutton class="text-center" id="demo-sb" v-model="dataSettings.rowno" min="1"
                    max="100"></b-form-spinbutton></b-col>
        </b-row>
        <hr />
        <b-row>
            <b-col><label><strong>{{ $translate('field_names') }}</strong></label> </b-col>
            <!-- -->
            <b-col><label>{{ $translate('columns') }}</label> </b-col>
        </b-row>
        <hr />
        <b-row v-for="(item, i) in dataFields" :key="'sss' + i">
            <!-- add required field askterisk if the field is required -->
            <b-col><label><strong>
                        {{ $translate(item.label) }}<span v-if="item.required" class="red">*</span></strong></label></b-col>
            <b-col v-if="!item.name.includes('date_format') && !item.name.includes('value_type_format')">
                <b-form-spinbutton :id="`'demo-sb-${item.name}`" v-model="dataSettings[item.name]"
                    :formatter-fn="convertToAlpha" min="-1" max="25" class="text-center"></b-form-spinbutton>
            </b-col>
            <!-- Add drop down for any date format selection fields -->
            <b-col v-else class="dd">
                <b-form-select class="form-control" v-model="dataSettings[item.name]" :options="item.options">
                </b-form-select>
            </b-col>
        </b-row>
        <b-row class="justify-content-end">
           
            <b-button variant="info" class="mt-2 me-3" size="fw" @click="$emit('input', dataSettings)">{{ $updateLabel()
            }}</b-button>
            <b-button v-if="ismasteritem == 'yes'" variant="info" class="mt-2 me-3" size="fw"
            @click="exportSampleFileWithData('master_item')">{{ $translate('export_csv_samle_file') }}</b-button>
            <b-button v-else-if="iscustomer == 'yes'" variant="info" class="mt-2 me-3" size="fw"
            @click="exportSampleFileWithData('customer')">{{ $translate('export_csv_samle_file') }}</b-button>
            <b-button v-else-if="isuser == 'yes'" variant="info" class="mt-2 me-3" size="fw"
            @click="exportSampleFileWithData('user')">{{ $translate('export_csv_samle_file') }}</b-button>
            <b-button v-else-if="isasset == 'yes'" variant="info" class="mt-2 me-3" size="fw"
            @click="exportSampleFileWithData('asset')">{{ $translate('export_csv_samle_file') }}</b-button>
            <b-button v-else-if="isworkflow == 'yes'" variant="info" class="mt-2 me-3" size="fw"
            @click="exportSampleFileWithData('workflow')">{{ $translate('export_csv_samle_file') }}</b-button>
            <b-button v-else-if="isworkflowtemplate == 'yes'" variant="info" class="mt-2 me-3" size="fw"
            @click="exportSampleFileWithData('workflow_template')">{{ $translate('export_csv_samle_file') }}</b-button>
            <b-button v-else-if="isrole == 'yes'" variant="info" class="mt-2 me-3" size="fw"
            @click="exportSampleFileWithData('role')">{{ $translate('export_csv_samle_file') }}</b-button>
            <b-button v-else-if="isuserroster == 'yes'" variant="info" class="mt-2 me-3" size="fw"
            @click="exportSampleFileWithData('roster')">{{ $translate('export_csv_samle_file') }}</b-button>
            <b-button v-else-if="isactivitytype == 'yes'" variant="info" class="mt-2 me-3" size="fw"
            @click="exportSampleFileWithData('activity_type')">{{ $translate('export_csv_samle_file') }}</b-button>
            <b-button v-else-if="isitemtype == 'yes'" variant="info" class="mt-2 me-3" size="fw"
            @click="exportSampleFileWithData('item_type')">{{ $translate('export_csv_samle_file') }}</b-button>
            <b-button v-else-if="istarget == 'yes'" variant="info" class="mt-2 me-3" size="fw"
            @click="exportSampleFileWithData('target')">{{ $translate('export_csv_samle_file') }}</b-button>
             <b-button v-else variant="info" class="mt-2 me-3" size="fw"
                @click="exportSampleFile">{{ $translate('export_csv_samle_file') }}</b-button>
        </b-row>
    </b-container>
</template>
<script>
import { capitalCase } from 'change-case'
import Papa from 'papaparse'
export default {
    name: 'UploadDataSettings',
    props: ['value', 'dataFields', 'subject','ismasteritem','iscustomer','isuser','isasset','isworkflow','isworkflowtemplate','isrole','isuserroster','isactivitytype','isitemtype','istarget'],
    data() {
        return {
            dataSettings: {},
        }
    },
    filters: {
        capitalize(x) {
            return capitalCase(x)
        },
    },
    watch: {
        value: {
            handler: function (val) {
                this.setSettings(val)
            },
            deep: true,
        },
    },
    mounted() {
        console.log('uploadDataSettings--mounted value', this.value)
        this.setSettings(this.value)
    },
    methods: {
        setSettings(_settings) {
            this.dataSettings = { ..._settings }
            for (const { name: key } of this.dataFields) {
                const value = this.dataSettings[key]
                if (typeof value == 'undefined' || value == null) {
                    this.$set(this.dataSettings, key, -1)
                }
            }
        },
        exportSampleFile() {
            const headerMapping = this.dataSettings
            const filteredHeaderMapping = Object.fromEntries(Object.entries(headerMapping).filter(([key]) => 
            key !== "rowno" && 
            key !== "schedule_at_date_format" && 
            key !== "is_selection_value_type_format" && 
            key !== 'is_mandatory_value_type_format' && 
            key !='ext_acc_bill_generate_value_type_format' && 
            key !='signature_required_value_type_format' && 
            key != 'attachment_required_value_type_format' && 
            key !='do_release_value_type_format' && 
            key != 'create_value_type_format' && 
            key !='view_value_type_format' && 
            key != 'update_value_type_format' && 
            key != 'delete_permission_value_type_format'&& 
            key != 'archived_value_type_format' && 
            key != 'is_completed_value_type_format'
        
        ));
            const headers = Object.keys(filteredHeaderMapping).map(key => key.split('_').map(part => part.charAt(0).toUpperCase() + part.slice(1)).join(' '));
            headers.sort((a, b) => filteredHeaderMapping[a] - filteredHeaderMapping[b]);
            const sortedHeaders = new Array(Math.max(...Object.values(filteredHeaderMapping)) + 1);
            headers.forEach((header, index) => {
                sortedHeaders[filteredHeaderMapping[Object.keys(filteredHeaderMapping)[index]]] = header;
            });
            const csv = Papa.unparse([sortedHeaders]);
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', `${this.subject}_sample`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },
        convertToAlpha(val) {
            return val > -1 ? String.fromCharCode(val + 65) : ''
        },

        async exportSampleFileWithData(module){
            switch(module){
                case 'master_item':
            let filters = this.$store.state.masterItem.filters;
            let query = this.$store.state.masterItem.query;
           
            await  this.$store.dispatch('masterItem/exportExcel', {
                filters,
                query
            })
           
                    break;
                case 'customer':
                let filters_c = this.$store.state.customers.filters;
            let query_c = this.$store.state.customers.query;
            await  this.$store.dispatch('customers/exportExcel', {
                filters_c,
                query_c
            })
                    break;
                    case 'user':
                let filters_u = this.$store.state.users.user_filter;
          
            await  this.$store.dispatch('users/exportExcelCSV', {
                filters_u,
              
            })
                    break;
                    case 'role':
                let filters_r = this.$store.state.roles.role_filter;
          
            await  this.$store.dispatch('roles/exportExcelCSV', {
                filters_r,
              
            })
                    break;
                    case 'asset':
                let filters_a = this.$store.state.assets.filters;
                let query_a  = this.$store.state.assets.query;
            await  this.$store.dispatch('assets/exportExcelCSV', {
                filters_a,
                query_a
            })
                    break;
                    case 'workflow':
               
                let query_w  = this.$store.state.checkoffTypes.filter;
            await  this.$store.dispatch('checkoffTypes/exportExcelCSV', {
                
                query_w
            })
                    break;
                    case 'workflow_template':
               
                let query_t  = this.$store.state.checkoffTemplates.filter;
            await  this.$store.dispatch('checkoffTemplates/exportExcelCSV', {
                
                query_t
            })
                    break;
                    case 'roster':
               
               let filter_r = this.$store.state.user_roster.filter;
               let query_r =  this.$store.state.user_roster.query;
           await  this.$store.dispatch('user_roster/exportExcelCSV', {
               
            filter_r,
            query_r
           })
                   break;
                   case 'activity_type':
               
               let query_at  = this.$store.state.orderType.filter;
           await  this.$store.dispatch('orderType/exportExcelCSV', {
               
            query_at
           })
                   break;
                   case 'item_type':
               
               let query_it  = this.$store.state.itemType.filter;
           await  this.$store.dispatch('itemType/exportExcelCSV', {
               
            query_it
           })
                   break;
                   case 'target':
               
                   let filter_target = this.$store.state.targets.filter;
                   let query_target =  this.$store.state.targets.query;
           await  this.$store.dispatch('targets/exportExcelCSV', {
               
            query_target,
            filter_target,
           })
                   break;

                default: 
                   break;
            }
        }
    },
}
</script>